<template>
  <div class="main-link-list">
    <div class="control-bar mob-visible-flex">
      <div class="swiper-button-prev swiper-footer-prev" slot="button-prev">
        <span class="material-icons">arrow_back_ios</span>
      </div>
      <div class="swiper-button-next swiper-footer-next" slot="button-next">
        <span class="material-icons">arrow_forward_ios</span>
      </div>
    </div>
    <swiper class="footer-swiper" ref="footerSwiper" :options="linkListSwiperOptions">
      <!--   강원특별자치도교육청   -->
      <swiper-slide class="education-office">
        <a href="https://www.gwe.go.kr/main/index.do" target="_blank" class="inner-wrap">
          <img src="@/assets/images/portal/icon/main/icon_educationOffice.png" alt="강원특별자치도교육청 새창 이동"/>
        </a>
      </swiper-slide>

      <!--   교육문화관/교육도서관   -->
      <swiper-slide class="education">
        <a href="https://lib.gwe.go.kr/" target="_blank" class="inner-wrap">
          <img src="@/assets/images/portal/icon/main/icon_inteEducation.png" alt="교육문화관/교육도서관 새창 이동"/>
        </a>
      </swiper-slide>

      <!--   독서로   -->
      <swiper-slide class="book">
        <a href="https://read365.edunet.net" target="_blank"
           class="inner-wrap">
          <img src="@/assets/images/portal/icon/main/icon_inteBook.png" alt="독서로 새창 이동"/>
        </a>
      </swiper-slide>

      <!--   강원교육-온   -->
      <swiper-slide class="gangwon-on">
        <a href="https://www.geti.or.kr/index.go" target="_blank" class="inner-wrap">
          <img src="@/assets/images/portal/icon/main/icon_gangwonOn.png" alt="강원교육온 새창 이동"/>
        </a>
      </swiper-slide>

      <!--   에듀넷   -->
      <swiper-slide class="edu">
        <a href="https://www.edunet.net/nedu/main/mainForm.do" target="_blank" class="inner-wrap">
          <img src="@/assets/images/portal/icon/main/icon_edu.png" alt="에듀넷 새창 이동"/>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
export default {
  name: "TheMainLinkList",
  data() {
    return {
      linkListSwiperOptions: {
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        slidesPerView: 5,
        spaceBetween: 0,
        slidesPerGroup: 1,
        breakpoints: {
          1024 : { slidesPerView: 3 },
          768  : { slidesPerView: 2 },
        },
        navigation: {
          nextEl: ".swiper-footer-next",
          prevEl: ".swiper-footer-prev"
        },
      },
      // 스와이퍼 재생
      swiperPlay: true,
    }
  },
  computed: {
    swiper() {
      return this.$refs.footerSwiper.swiper
    },
  },
  watch: {
    swiperPlay() {
      if ( this.swiperPlay ) {
        this.swiper.autoplay.start();
      }
      else {
        this.swiper.autoplay.stop();
      }
    }
  },
}
</script>
<style scoped>
</style>
